module.exports = __webpack_public_path__ + "public/19ca4d35c8f94db0fa14422334dd2ad3.woff";